import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useI18n } from "@/i18n";
import { langPath } from "@/lib/paths";

export default function Footer() {
  const { t, language } = useI18n();

  return (
    <footer className="bg-[color:var(--rv-ink)] text-[color:var(--rv-bg)]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Logo className="h-10 w-10 rounded-lg" />
              <div>
                <div className="font-serif text-xl">{t("nav.brand")}</div>
                <div className="text-[11px] uppercase tracking-[0.2em] opacity-70">{t("nav.brandTag")}</div>
              </div>
            </div>
            <p className="text-sm opacity-80 max-w-xs">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="text-[11px] uppercase tracking-[0.2em] opacity-60 mb-4">{t("footer.columns.site")}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to={langPath(language, "/")} className="opacity-90 hover:opacity-100">{t("nav.home")}</Link></li>
              <li><a href={langPath(language, "/#how")} className="opacity-90 hover:opacity-100">{t("nav.howItWorks")}</a></li>
              <li><a href={langPath(language, "/#projects")} className="opacity-90 hover:opacity-100">{t("nav.projects")}</a></li>
              <li><a href={langPath(language, "/#contact")} className="opacity-90 hover:opacity-100">{t("nav.contact")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] uppercase tracking-[0.2em] opacity-60 mb-4">{t("footer.columns.legal")}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to={langPath(language, "/privacy")} className="opacity-90 hover:opacity-100">{t("nav.privacy")}</Link></li>
              <li><Link to={langPath(language, "/cookies")} className="opacity-90 hover:opacity-100">{t("nav.cookies")}</Link></li>
              <li><Link to={langPath(language, "/terms")} className="opacity-90 hover:opacity-100">{t("nav.terms")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] uppercase tracking-[0.2em] opacity-60 mb-4">{t("footer.columns.company")}</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li>{t("footer.companyName")}</li>
              <li>{t("footer.registration")}</li>
              <li>{t("footer.taxId")}</li>
              <li>{t("footer.license")}</li>
              <li>{t("footer.jurisdiction")}</li>
              <li>{t("footer.incorporated")}</li>
              <li>
                <a href="mailto:contacto@ronaviraxa.com" className="underline underline-offset-4 opacity-90 hover:opacity-100">contacto@ronaviraxa.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs opacity-80">
          <div>{t("footer.copy")}</div>
          <div className="max-w-2xl">{t("footer.risk")}</div>
        </div>
      </div>
    </footer>
  );
}
